import { PrimaryButton } from 'approot/shared/styles/buttons';
import * as Styled from './suggested-answer-preview.style';

type Props = {
  ariaLabel?: string;
  onClick: () => void;
};

const SuggestedAnswerPreview = ({ ariaLabel, onClick }: Props) => (
  <Styled.SuggestedAnswerPreview>
    <PrimaryButton
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      data-selector="btn-show-answers"
    >
      Show Answers
    </PrimaryButton>
  </Styled.SuggestedAnswerPreview>
);

export default SuggestedAnswerPreview;
